module.exports = __webpack_public_path__ + "static/media/shutterstock_1211695423.742a3e44.jpg";